// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__27n01","dragIcon":"Choice_dragIcon__1_aNX","left":"Choice_left__10ssQ","input":"Choice_input__FGpFa"};